module.exports = __webpack_public_path__ + "static/media/do.d052e0b2.png";